import { Button, Chat, Grid, Group, Layout, Page, Table } from "@/comn/components";
import {
    useAuth,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    usePopup,
    useResource,
    useStore,
    useToast,
} from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_IQS_CMNT, SG_IQS, URLS } from "@/tra/tancis/ptli/mypage/myiqs/services/ptliMypageIqsService";
import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

/*
 * Common Code Valid Value Details
 * !== 공통 코드 유효 값 상세 ==!
 */
export const PTLI03040002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    });
    const { t } = useTranslation();
    const toast = useToast();
    const { iqsUuid: iqsUuid } = useParams();
    const navigate = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const modal = useModal();
    // input 요소에 대한 ref 배열 생성
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    interface IQS {
        comnCd: string;
        trgtDispYn: string;
        iqsSbjctlList?: sbjct[];
        iqsTrgtList?: string[];
    }

    // Subject of Converstion Topic !== IQS 주제항목 ==!
    interface sbjct {
        iqsUuid: string;
        iqsSbjctlSn: number;
        iqsSbjctlLblNm: string;
        iqsSbjctlValue: string;
        iqsSbjctlTpCd: string;
        comnCd: string;
        defaultValue?: string;
        options: comnCdOptions[];
    }

    // IQS Target List !== IQS 대상자 목록 ==!
    interface trgt {
        usrId: string;
        iqsUuid?: string;
    }

    interface comnCdOptions {
        label: string;
        value: string;
    }

    const form = {
        iqsCmnt: useForm({
            defaultSchema: SF_IQS_CMNT,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const fetch = {
        // View a IQS Detail !== IQS 상세 조회 ==!
        getIQSInfo: useFetch({
            api: () => APIS.getIQSInfo(iqsUuid),
            onSuccess: (data: any) => {
                console.log(data);
                console.log(data?.iqsInfo.content.iqsTrgtList.some((item : any) => item.usrId === auth.get("usrId")))
            },
        }),

        // Save Bulletin board Reply !== 답변 등록 ==!
        registIqsComment: useFetch({
            api: () =>
                APIS.registIqsComment({
                    ...form.iqsCmnt.getValues(),
                    iqsUuid: iqsUuid,
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        location.reload();
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli0304001q}?menuId=${menuId}`),

        onSubmitBtnClick: form.iqsCmnt.handleSubmit(() => {
            if (!handler.validChk()) return;
            modal.openModal({
                content: "msg.com.00047", // Confirm save? !== 저장하시겠습니까? ==!
                onConfirm: () => fetch.registIqsComment.fetch(),
            });
        }),

        validChk: () => {
            if (comnUtils.isEmpty(fetch.getIQSInfo.data?.iqsInfo.content.comnCd)) {
                return true;
            }
            const cdVldVal = form.iqsCmnt.getValue("cdVldVal");
            if (typeof cdVldVal === "undefined" || cdVldVal === "") {
                form.iqsCmnt.setError("cdVldVal", {
                    message: "msg.com.00005", // Mandatory fields !== 필수 입력 필드 ==!
                });
                return false;
            }
            form.iqsCmnt.clearErrors("cdVldVal");
            return true;
        },
    };

    useEffect(() => {
        fetch.getIQSInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    {/* IQS Subject of Converstion Topic Start  !== IQS 주제 Start ==!*/}
                    <Group.Section>
                        {fetch.getIQSInfo.data?.iqsInfo.content.iqsSbjctlList && (
                            <>
                                {fetch.getIQSInfo.data?.iqsInfo.content.iqsSbjctlList.map(
                                    (obj: any, index: any) =>
                                        index % 2 === 0 && (
                                            <Group.Row key={index}>
                                                {" "}
                                                {/* Use index %2 to hold two each !== 2개씩 담기 위해 index % 2를 사용 ==!*/}
                                                <>
                                                    <Group.Control
                                                        type="text"
                                                        label={obj.iqsSbjctlLblNm}
                                                        value={obj.iqsSbjctlValue}
                                                        edit={false}
                                                    />
                                                    {/* Add a new control if you have the following controls !== 다음 Control이 있으면 새로운 Control을 추가 ==!*/}
                                                    {index + 1 <
                                                        fetch.getIQSInfo.data?.iqsInfo.content.iqsSbjctlList.length && (
                                                        <Group.Control
                                                            type="text"
                                                            label={
                                                                fetch.getIQSInfo.data?.iqsInfo.content.iqsSbjctlList[
                                                                    index + 1
                                                                ].iqsSbjctlLblNm
                                                            }
                                                            value={
                                                                fetch.getIQSInfo.data?.iqsInfo.content.iqsSbjctlList[
                                                                    index + 1
                                                                ].iqsSbjctlValue
                                                            }
                                                            edit={false}
                                                        />
                                                    )}
                                                </>
                                            </Group.Row>
                                        ),
                                )}
                            </>
                        )}
                    </Group.Section>
                    {/* IQS Subject of Converstion Topic End  !== IQS 주제 End ==!*/}
                    {/* IQS Comment Detail Start  !== IQS 댓글 조회 Start ==!*/}
                    <Group.Section>
                        <Chat
                            data={fetch.getIQSInfo.data?.iqsInfo.content.iqsCmntList.map((item: any) => {
                                const position = item.frstRegstId === auth.get("usrId") ? "right" : undefined;

                                return {
                                    date: item.frstRgsrDtm,
                                    name: fetch.getIQSInfo.data?.iqsInfo.content.comnCd
                                        ? `${item.frstRegstId} (${item.cdVldValNm})`
                                        : item.frstRegstId,
                                    content: item.iqsCmntCn,
                                    position: position,
                                };
                            })}
                        />
                    </Group.Section>
                    {/* IQS Comment Detail End  !== IQS 댓글 조회 End ==!*/}
                    {/* IQS Comment Form Start  !== IQS 댓글 작성양식 Start ==!*/}
                    {/* Enable comment creation only if you are not an IQS registered with a specific docCdVal, or if you are registered with iqsTargetList
                        !== 특정 docCdVal 로 등록된 IQS가 아니거나, iqsTargetList 에 등록된 사람일 경우에만 댓글 작성 활성화 ==!*/}
                    { (!["CUSDEC501", "edoc_clr0002"].includes(fetch.getIQSInfo.data?.iqsInfo.content.docCdVal)
                        || fetch.getIQSInfo.data?.iqsInfo.content.iqsTrgtList.some((item : any) => item.usrId === auth.get("usrId")))
                        && (
                            <Group.Section>
                                {fetch.getIQSInfo.data?.iqsInfo.content.comnCd ? (
                                    <Group.Row>
                                        <Group.Control {...form.iqsCmnt.schema.iqsCmntCn} controlSize={10} />
                                        {fetch.getIQSInfo.data?.iqsInfo.content.comnCdChildList.length > 0 ? (
                                            <Group.Control
                                                {...form.iqsCmnt.schema.cdVldVal}
                                                controlSize={1}
                                                options={fetch.getIQSInfo.data?.iqsInfo.content.comnCdChildList.map(
                                                    (item: any) => ({
                                                        label: item.cdVldValNm,
                                                        value: item.cdVldVal,
                                                    }),
                                                )}
                                                require={true}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                        <Group.Col colSize={1}>
                                            <Button role="save" onClick={() => handler.onSubmitBtnClick()} />
                                        </Group.Col>
                                    </Group.Row>
                                ) : (
                                    <Group.Row>
                                        <Group.Control {...form.iqsCmnt.schema.iqsCmntCn} controlSize={11} />
                                        <Group.Col colSize={1}>
                                            <Button role="save" onClick={() => handler.onSubmitBtnClick()} />
                                        </Group.Col>
                                    </Group.Row>
                                )}
                            </Group.Section>
                        )
                    }
                    
                    {/* IQS Comment Form End  !== IQS 댓글 작성양식 End ==!*/}
                </Group.Body>
            </Group>
            <Layout direction="row" key="default">
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={() => handler.onListBtnClick()} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
